import React from "react";

const BASE_WIDTH = 215;
const BASE_HEIGHT = 128;

export default function SupportSeagullIcon(props: {
  height?: number;
  width?: number;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${BASE_WIDTH} ${BASE_HEIGHT}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 128H214.088C207.033 74.9328 161.797 34 107.044 34C52.2911 34 7.05456 74.9328 0 128Z"
        fill="#F3F3F3"
      />
      <rect
        x="83.0367"
        y="42.1562"
        width="55.2174"
        height="121.651"
        rx="27.6087"
        fill="#E5F7FF"
      />
      <circle cx="100.882" cy="72.8825" r="3.88247" fill="#3CACEB" />
      <circle cx="127.882" cy="72.8825" r="3.88247" fill="#3CACEB" />
      <ellipse
        cx="114.55"
        cy="94.6316"
        rx="18.5496"
        ry="8.62772"
        fill="#06C5EF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.099 94.6277C133.099 89.8628 124.794 86 114.55 86C104.305 86 96.0001 89.8628 96.0001 94.6277H133.099Z"
        fill="#47DDFE"
      />
      <path
        d="M151.519 105.625H141.409C140.496 105.625 139.706 105.292 139.039 104.625C138.372 103.958 138.038 103.168 138.038 102.255V68.553C138.038 67.6403 138.372 66.8504 139.039 66.1834C139.706 65.5164 140.496 65.1828 141.409 65.1828H144.779C144.779 54.7914 141.883 46.5765 136.09 40.5382C130.297 34.5 121.96 31.4808 111.077 31.4808C100.194 31.4808 91.8561 34.5 86.0635 40.5382C80.271 46.5765 77.3747 54.7914 77.3747 65.1828H80.7449C81.6577 65.1828 82.4476 65.5164 83.1146 66.1834C83.7816 66.8504 84.1151 67.6403 84.1151 68.553V102.255C84.1151 103.168 83.7816 103.958 83.1146 104.625C82.4476 105.292 81.6577 105.625 80.7449 105.625H77.3747C77.3747 109.347 78.6912 112.524 81.3242 115.157C83.9572 117.79 87.1343 119.106 90.8555 119.106H97.5959C97.5959 117.21 98.2454 115.613 99.5443 114.314C100.843 113.015 102.441 112.366 104.336 112.366H111.077C112.972 112.366 114.57 113.015 115.869 114.314C117.168 115.613 117.817 117.193 117.817 119.053C117.817 120.914 117.168 122.511 115.869 123.845C114.57 125.179 112.972 125.847 111.077 125.847H90.8555C85.2385 125.847 80.4641 123.881 76.5322 119.949C72.6003 116.017 70.6343 111.242 70.6343 105.625C66.9131 105.625 63.7359 103.659 61.103 99.7274C58.47 95.7955 57.1535 91.0211 57.1535 85.4041C57.1535 81.753 57.7679 78.3828 58.9966 75.2935C60.2253 72.2041 61.8577 69.7818 63.8939 68.0265V65.1828C63.8939 58.7935 65.1402 52.685 67.6327 46.8574C70.1253 41.0297 73.4779 36.0095 77.6907 31.7968C81.9034 27.584 86.9236 24.2314 92.7513 21.7388C98.5789 19.2463 104.687 18 111.077 18C117.466 18 123.575 19.2463 129.402 21.7388C135.23 24.2314 140.25 27.584 144.463 31.7968C148.676 36.0095 152.028 41.0297 154.521 46.8574C157.013 52.685 158.26 58.7935 158.26 65.1828V68.0265C160.296 69.7818 161.928 72.2041 163.157 75.2935C164.386 78.3828 165 81.753 165 85.4041C165 91.0211 163.684 95.7955 161.051 99.7274C158.418 103.659 155.24 105.625 151.519 105.625Z"
        fill="#9696A0"
      />
      <path
        d="M57.1535 86.1564C56.1181 75.8031 61.4673 69.3335 64.4871 67.608C64.4871 67.608 65.9216 66.7284 67.0754 66.3138C68.2807 65.8808 69.5261 65.6789 70.5264 65.451C73.175 64.8475 77.4286 65.0184 77.4286 65.0184H81.3111C83.7268 65.0184 84.3308 67.0316 84.3308 68.0381V102.549C84.3308 104.965 82.6052 105.569 81.7425 105.569H77.4286H70.5264C62.3301 103.843 58.4476 99.0979 57.1535 86.1564Z"
        fill="#83838D"
      />
      <path
        d="M164.869 86.1564C165.904 75.8031 160.555 69.3335 157.535 67.608C157.535 67.608 156.101 66.7284 154.947 66.3138C153.742 65.8808 152.496 65.6789 151.496 65.451C148.847 64.8475 144.594 65.0184 144.594 65.0184H140.711C138.296 65.0184 137.692 67.0316 137.692 68.0381V102.549C137.692 104.965 139.417 105.569 140.28 105.569H144.594H151.496C159.692 103.843 163.575 99.0979 164.869 86.1564Z"
        fill="#83838D"
      />
      <rect
        x="96.841"
        y="112.043"
        width="21.5693"
        height="13.8044"
        rx="6.90218"
        fill="#83838D"
      />
      <path
        d="M58.1748 106.286L85.2743 131.973L58.5674 145.732C55.4152 142.025 47.4632 129.845 40.8724 110.775C32.6339 86.9382 58.1093 69.8424 59.9181 70.5132C61.3652 71.0498 61.1185 73.5646 60.8143 74.7549C59.1401 77.9749 55.3799 85.4145 53.7326 89.4126C52.0853 93.4108 56.0077 102.328 58.1748 106.286Z"
        fill="#64BDEF"
      />
      <path
        d="M59.9183 104.5C62.9183 108.5 89.8901 134.512 89.8901 134.512L63.9091 142.985C60.757 139.278 53.5142 129.624 46.9234 110.554C38.6849 86.7176 58.2029 70.7028 59.9183 70.5169C61.4527 70.3506 61.1187 73.5683 60.8145 74.7587C59.1403 77.9787 55.253 85.2926 54.9005 89.6024C54.5 94.5 56.9183 100.5 59.9183 104.5Z"
        fill="#E5F7FF"
      />
      <path
        d="M121 51.2418C125.932 48.7086 124.74 45.4366 123.49 44.1172H99.2132C97.9624 45.4366 96.7711 48.7086 101.703 51.2418C106.634 53.775 111.351 54.6721 111.351 54.6721C111.351 54.6721 116.069 53.775 121 51.2418Z"
        fill="#3CACEB"
      />
      <path
        d="M105.42 25.8466C109.2 24.7178 113.226 24.7178 117.006 25.8466C124.873 28.1959 136.559 36.6474 123.673 42.1249L122.91 42.76L99.2702 42.76L98.7528 42.1249C85.8663 36.6474 97.553 28.1958 105.42 25.8466Z"
        fill="#E5F7FF"
      />
      <path
        d="M99.7641 40.3159C101.403 40.8512 105.098 41.765 111.219 41.765C117.339 41.765 121.034 40.8513 122.673 40.3159C123.169 40.1539 123.679 40.5226 123.679 41.0445L123.679 44.3894C122.129 45.1427 120.138 45.6624 118.204 46.0194C113.588 46.8717 108.849 46.8717 104.233 46.0194C102.299 45.6622 100.308 45.1427 98.7586 44.3894L98.7586 41.0445C98.7586 40.5226 99.2679 40.1539 99.7641 40.3159Z"
        fill="#6BC3F4"
      />
      <path
        d="M111.61 38.8108C111.61 38.922 111.572 39.0208 111.495 39.1073C111.417 39.1938 111.321 39.237 111.205 39.237C110.935 39.237 110.8 39.1073 110.8 38.8479L110.8 38.8108C109.951 38.712 109.221 38.3754 108.61 37.801C107.999 37.2266 107.642 36.5317 107.539 35.7164C107.5 35.4817 107.622 35.3397 107.905 35.2903C108.008 35.2656 108.108 35.2872 108.204 35.3551C108.301 35.4231 108.356 35.5188 108.368 35.6423C108.446 36.26 108.713 36.788 109.169 37.2266C109.626 37.6651 110.17 37.9276 110.8 38.0141L110.8 34.4935L109.565 34.4935C109.436 34.4935 109.333 34.4564 109.256 34.3823C109.179 34.3082 109.14 34.2156 109.14 34.1044C109.14 33.8326 109.282 33.6967 109.565 33.6967L110.8 33.6967L110.8 32.8815C110.44 32.795 110.144 32.6066 109.912 32.3163C109.681 32.026 109.565 31.6956 109.565 31.325C109.565 30.8926 109.726 30.5221 110.047 30.2132C110.369 29.9044 110.755 29.75 111.205 29.75C111.655 29.75 112.041 29.9044 112.363 30.2132C112.685 30.5221 112.846 30.8926 112.846 31.325C112.846 31.6956 112.73 32.0229 112.498 32.307C112.267 32.5912 111.971 32.7826 111.61 32.8815L111.61 33.6967L112.846 33.6967C113.129 33.6967 113.27 33.8326 113.27 34.1044C113.27 34.2156 113.231 34.3082 113.154 34.3823C113.077 34.4564 112.974 34.4935 112.846 34.4935L111.61 34.4935L111.61 38.0141C112.254 37.9276 112.807 37.662 113.27 37.2173C113.733 36.7726 113.991 36.2476 114.042 35.6423C114.081 35.3706 114.248 35.2532 114.544 35.2903C114.788 35.3397 114.91 35.4817 114.91 35.7164C114.782 36.5441 114.412 37.2451 113.801 37.8195C113.19 38.3939 112.46 38.7244 111.61 38.8108ZM112.035 31.325C112.035 31.115 111.951 30.9328 111.784 30.7784C111.617 30.624 111.424 30.5468 111.205 30.5468C110.986 30.5468 110.794 30.624 110.626 30.7784C110.459 30.9328 110.375 31.115 110.375 31.325C110.375 31.5473 110.459 31.7357 110.626 31.8901C110.794 32.0445 110.986 32.1218 111.205 32.1218C111.424 32.1218 111.617 32.0445 111.784 31.8901C111.951 31.7357 112.035 31.5473 112.035 31.325Z"
        fill="#F5DC1D"
      />
      <defs>
        <filter
          id="filter0_d"
          x="34"
          y="-4"
          width="136"
          height="136"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <clipPath id="clip0">
          <rect width="214.088" height="128" fill="white" />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="128"
            height="128"
            fill="white"
            transform="matrix(-1 0 0 1 166 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
